import React, { Component } from 'react'
import CallSearch from '../search/calls/runSearch.js'
import SearchMainLayout from '../search/layout/main/searchMainLayout.js'
import MetaTags from '../elements/meta/metaTags.js'
import ListingSearchSchema from '../elements/meta/listingSearchSchema.js'
import { MAPBOX_API_KEY } from 'constants/index.js'
var geo = require('mapbox-geocoding')
geo.setAccessToken(MAPBOX_API_KEY)

class Listings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      latitude: null,
      longitude: null,
      loading: true,
      city: null,
      regionAbbr: null,
      formattedCity: '',
      formattedState: '',
    }
  }

  async componentDidMount() {
    const titleCase = (str) => {
      if (!str) {
        return ""
      }
      var splitStr = str?.toLowerCase()?.split(' ')
      if (splitStr && splitStr?.length > 0) {
        for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] =
            splitStr[i]?.charAt(0)?.toUpperCase() + splitStr[i]?.substring(1)
        }
        return splitStr?.join(' ')
      } else {
        return str
      }
    }

    const { search } = this.props.location
    const params = new URLSearchParams(search)

    const city = this.props.match.params.city
    const region = this.props.match.params.region
    const make = this.props.match.params.make ? this.props.match.params.make :  params.get('makes')
    const category = this.props.match.params.category ? this.props.match.params.category : params.get('category')
    const activeInstantBooking = this.props.match.params.instantBooking
    let address = region

    if (city) {
      address = city + ',' + region
    }
    address = address ? address : city
    geo.geocode('mapbox.places', address, (err, geoData) => {
      this.setState({
        latitude: geoData?.features[0]?.center[1],
        longitude: geoData?.features[0]?.center[0],
        address: address,
        activeInstantBooking: activeInstantBooking ?? false,
        formattedCity: titleCase(this.props?.match?.params?.city),
        city: city,
        formattedState: region.toUpperCase(),
        makes: make ? [make] : [],
        category: category ? [category] : [],
        loading: false,
        regionAbbr: region,
      })
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.loading && <div></div>}
        {!this.state.loading && (
          <CallSearch
            parseURLOnMount={false}
            updateOnLocationURLChange={false}
            appendURLParams={false}
            searchFilters={{
              instantBooking: this.state.activeInstantBooking,
              location: this.state.address,
              latitude: this.state.latitude,
              longitude: this.state.longitude,
              makes: this.state.makes,
              category: this.state.category,
            }}
            searchDescription={'Search Call from Listings.js Component'}
            render={({
              searchLoading,
              runSearch,
              searchError,
              hasSearchData,
              searchData,
              initialURLParams,
              mapboxSearchLoading,
              mapboxSearchError,
              hasMapboxSearchData,
              runMapBoxSearch,
              groupedMarkers,
              allCoordinates,
              advertisement
            }) => {
              return (
                <React.Fragment>
                  {!searchLoading && (
                    <MetaTags
                      title={
                        !searchData?.results_meta
                          ? this.state.formattedCity +
                          ', ' +
                          this.state.formattedState
                          : ' Motorcycle Rentals in ' +
                          this.state.formattedCity +
                          ', ' +
                          this.state.formattedState +
                          ' | Twisted Road'
                      }
                      description={
                        'Twisted Road provides the most convenient online motorcycle rentals in ' +
                        this.state.formattedCity +
                        ', ' +
                        this.state.formattedState +
                        '. Find your next motorcycle rental now.'
                      }
                      facebookDescription={
                        'Twisted Road provides the most convenient online motorcycle rentals in ' +
                        this.state.formattedCity +
                        ', ' +
                        this.state.formattedState +
                        '. Find your next motorcycle rental now.'
                      }
                      url={window.location.href}
                      setPrerenderStatusCode={!hasSearchData}
                    />
                  )}
                  <ListingSearchSchema searchData={searchData} />
                  <SearchMainLayout
                    isAuth={this.props.isAuth}
                    searchLoading={searchLoading}
                    runSearch={runSearch}
                    searchError={searchError}
                    hasSearchData={hasSearchData}
                    searchData={searchData}
                    initialValues={initialURLParams}
                    appendURLParams={false}
                    disableMetaTags={true}
                    mapboxSearchLoading={mapboxSearchLoading}
                    mapboxSearchError={mapboxSearchError}
                    hasMapboxSearchData={hasMapboxSearchData}
                    runMapBoxSearch={runMapBoxSearch}
                    groupedMarkers={groupedMarkers}
                    allCoordinates={allCoordinates}
                    advertisement={advertisement}
                  />
                </React.Fragment>
              )
            }}
          />
        )}
      </React.Fragment>
    )
  }
}
export default Listings
